import styled from 'styled-components';

import { GetActiveOrganizationsQuery, GetSitesQuery, GetUserQuery } from 'data/__generated__';

import { IdentityBanner } from './IdentityBanner';
import { IdentityContactSection } from './IdentityContactSection';
import { OrganizationGroupsSection } from './OrganizationGroupsSection';
import { VisitedSitesSection } from './VisitedSitesSection';

type Props = {
    user: NonNullable<GetUserQuery['userFromAdmin']>;
    organizations: GetActiveOrganizationsQuery['activeOrganizations'];
    sites: GetSitesQuery['sites'];
};

export const IdentitySection = ({ user, organizations, sites }: Props) => {
    return (
        <Container>
            <IdentityBanner user={user} />
            <Divider />
            <Grid>
                <Block>
                    <BlockTitle>Identité & contact</BlockTitle>
                    <IdentityContactSection user={user} />
                </Block>
                <Block>
                    <BlockTitle>Organisation</BlockTitle>
                    <OrganizationGroupsSection user={user} organizations={organizations} />
                </Block>
                <Block>
                    <BlockTitle>Sites visités</BlockTitle>
                    <VisitedSitesSection sites={sites} />
                </Block>
            </Grid>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

const Divider = styled.div`
    height: 1px;
    background-color: ${({ theme }) => theme.lightBorderColor};
`;

const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;

    @media (max-width: 1100px) {
        grid-template-columns: 1fr;
    }
`;

const Block = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    min-width: 0;
`;

const BlockTitle = styled.h3`
    margin: 0;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: ${({ theme }) => theme.textColor};
    opacity: 0.7;
`;
